import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_site = _resolveComponent("site")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_ibps_status = _resolveComponent("ibps-status")!
  const _component_payment_status_event = _resolveComponent("payment-status-event")!
  const _component_sms_template = _resolveComponent("sms-template")!
  const _component_email_template = _resolveComponent("email-template")!
  const _component_payment_portal_status = _resolveComponent("payment-portal-status")!
  const _component_check_status = _resolveComponent("check-status")!
  const _component_payment_method = _resolveComponent("payment-method")!
  const _component_payment_status_mapping = _resolveComponent("payment-status-mapping")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: _ctx.name }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tabs, { "tab-position": "left" }, {
        default: _withCtx(() => [
          (_ctx.canView('sites'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "1",
                tab: "Business Unit"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_site)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canView('ibps_statuses'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "2",
                tab: "IBPS Status"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ibps_status)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canView('payment_status_events'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "3",
                tab: "Data Source"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_payment_status_event)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canView('sms_templates'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "4",
                tab: "SMS Templates"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_sms_template)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canView('email_templates'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "5",
                tab: "Email Templates"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_email_template)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canView('payment_portal_statuses'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "6",
                tab: "Payment Portal Status"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_payment_portal_status)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canView('check_statuses'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "7",
                tab: "Check Statuses"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_check_status)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canView('payment_methods'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "8",
                tab: "Mode of Payments"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_payment_method)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canView('payment_status_mappings'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "9",
                tab: "Payment Status Mappings"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_payment_status_mapping)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}